// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"39e88a9c","703":"8cbfcd7b","787":"06b30326"}[chunkId] + ".chunk.js";
};